import { render, staticRenderFns } from "./proofMonthStrip.vue?vue&type=template&id=1ecc860a&scoped=true"
import script from "./proofMonthStrip.vue?vue&type=script&lang=js"
export * from "./proofMonthStrip.vue?vue&type=script&lang=js"
import style0 from "./proofMonthStrip.vue?vue&type=style&index=0&id=1ecc860a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc860a",
  null
  
)

export default component.exports